import h from 'hyperscript';
import getTarget from 'javascripts/utils/get-target';
import { t } from 'javascripts/utils/withTranslation';

const LOCALSTORAGE_KEY = 'fb-teaser-active';
const isFbTeaserActive = () => localStorage.getItem(LOCALSTORAGE_KEY);

let iFrameSrc;

const handleFacebook = () => {
  const fbSplashs = document.querySelectorAll('.js-facebook-splash');

  fbSplashs.forEach(($fbSplash) => {
    const $fbContentBox = $fbSplash.closest('.facebook-box__content');
    const $previewImage = $fbSplash.querySelector('.facebook-box__image');
    let previewImageSrc = '';

    if ($previewImage) {
      previewImageSrc = $previewImage.src;
    } else {
      previewImageSrc = $fbContentBox.getAttribute('data-placeholder');
    }

    iFrameSrc = iFrameSrc || $fbSplash.href;

    let fbTeaser = null;
    if (isFbTeaserActive()) {
      fbTeaser = h(
        'div.facebook-box__content-inner',
        h('iframe.facebook-box__iframe', {
          src: iFrameSrc,
          scrolling: 'no',
          frameboarder: '0',
          allowtransparency: 'true',
        }),
        h(
          'button.link.facebook-box__link.js-facebook-splash',
          {
            type: 'button',
            'aria-label': 'Facebook Plugin deaktivieren',
          },
          t('Facebook-Plugin deaktivieren'),
        ),
      );
    } else {
      fbTeaser = h('a.js-facebook-splash', {
        href: iFrameSrc,
      }, h(
        'div.facebook-box__content-inner',
        h('img.facebook-box__image', {
          src: previewImageSrc,
        }),
        h(
          'p.facebook-box__text',
          t('Erst durch Klicken wird dieses Modul aktiv und es werden Daten an Facebook übermittelt. Über den Datenschutzschalter können Sie die Aktivierung rückgängig machen.'),
        ),
      ));
    }

    while ($fbContentBox.hasChildNodes()) {
      $fbContentBox.removeChild($fbContentBox.lastChild);
    }

    $fbContentBox.appendChild(fbTeaser);
    $fbContentBox.setAttribute('data-placeholder', previewImageSrc);
  });
};

document.addEventListener('click', (event) => {
  if (getTarget(event.target, '.js-facebook-splash')) {
    event.preventDefault();

    if (isFbTeaserActive()) {
      localStorage.removeItem(LOCALSTORAGE_KEY);
    } else {
      localStorage.setItem(LOCALSTORAGE_KEY, true);
    }

    handleFacebook();
  }
});

handleFacebook();
